const en = {
  name: 'name',
  info: {
    age: 'age'
  }
}
export default en
